import { images } from "helpers/images";

const Footer = () => {
  const footerLinks = [
    {
      title: "Quick Links",
      links: [
        { label: "Packages", to: "/packages", type: "link" },
        { label: "Blog", href: "https://blog.zynerd.com", type: "a" },
        { label: "News", href: "https://blog.zynerd.com/news", type: "a" },
        { label: "Careers", to: "/careers", type: "link" },
        { label: "Contact us", to: "/contact-us", type: "link" },
      ],
    },
    {
      title: "Exams",
      links: [
        { label: "NEET UG", to: "/neet-ug", type: "link" },
        { label: "NEET PG", to: "/neet-pg", type: "link" },
        { label: "NEET MDS", to: "/neet-mds", type: "link" },
        { label: "INICET", to: "/inicet", type: "link" },
        { label: "DNB PDCET", to: "/dnb-pdcet", type: "link" },
        { label: "NEET SS", to: "/neet-ss", type: "link" },
      ],
    },
    {
      title: "Partner with us",
      links: [
        { label: "Be our Ambassador", to: "/ambassador", type: "link" },
        { label: "Influencer Program", to: "/influencer-program", type: "link" },
      ],
    },
    {
      title: "Legal",
      links: [
        { label: "Privacy Policy", to: "/privacy-policy", type: "link" },
        { label: "Package Policy", to: "/package-policy", type: "link" },
        { label: "Terms & Conditions", to: "/terms-and-conditions", type: "link" },
      ],
    },
  ];

  return (
    <footer className="bg-grey-800 text-white px-6 py-10 rounded-3xl sm:my-6 m-4 sm:mx-6 ">
      <div className="max-sm:mx-auto mx-10 my-8 flex flex-col md:flex-row justify-between items-center sm:items-start gap-10">
        <div className="flex flex-col justify-center items-center sm:items-start gap-10">
          <div className="flex items-center gap-2">
            <a href="/">
              <img
                src={images.logo}
                alt="ZyNerd Logo"
                className="w-60 h-16 transition-transform duration-300 hover:scale-105 object-contain cursor-pointer"
              />
            </a>
          </div>
          <div className="flex gap-2">
            <a
              className="transition-transform duration-300 hover:scale-105"
              href="https://play.google.com/store/apps/details?id=com.zynerd.portal"
              target="_blank"
            >
              <img
                src={images.googlePlay}
                alt="Google Play"
                className="w-40 h-12 transition-transform duration-300 object-contain hover:scale-100"
              />
            </a>
            <a
              className="transition-transform duration-300 hover:scale-105"
              href="https://apps.apple.com/in/app/zynerd-neet-ug-pg-mds/id6504278658"
              target="_blank"
            >
              <img
                src={images.appStore}
                alt="App Store"
                className="w-40 h-12 transition-transform duration-300 hover:scale-100 object-contain"
              />
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:flex gap-10 text-center sm:text-left">
          {footerLinks.map((section, idx) => (
            <div key={idx}>
              <h3 className="font-bold text-2xl !pb-4">{section.title}</h3>
              <ul className="font-medium space-y-4 sm:space-y-3 text-sm">
                {section.links.map((item, i) => (
                  <li key={i}>
                    {item.type === "link" ? (
                      <a
                        className="transition-transform duration-300 hover:scale-110 inline-block text-base leading-constrict"
                        href={item.to}
                      >
                        {item.label}
                      </a>
                    ) : (
                      <a
                        href={item.href}
                        className="transition-transform duration-300 hover:scale-110 inline-block text-base"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <p className="text-center text-sm text-grey-50 mt-10">
        © 2025 Frank & David Labs Private Limited
      </p>
    </footer>
  );
};

export default Footer;
